import Vue from "vue";
import { i18n } from "@/translations/i18nSetup";

function toHoursAndMinutes(totalSeconds) {
  const totalMinutes = Math.floor(totalSeconds / 60);

  const seconds = totalSeconds % 60;
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return { h: hours, m: minutes, s: seconds };
}

function fullNameFormat(name) {
  return i18n.t("3437", { first: name.first, last: name.last });
}

Vue.filter("timeToI18nFormat", seconds => {
  if (!seconds) return "";
  if (seconds < 60) return i18n.t("30095");

  const date = toHoursAndMinutes(seconds);
  const hours = i18n.t("30009", {str: date.h });
  const minutes =  i18n.t("30010", {str: date.m});

  return date.h === 0 ? minutes : hours + " " + minutes;
});

Vue.filter("timeToDateFormat", seconds => {
  if (!seconds) return 0;

  const totalMs = seconds * 1000;
  return new Date(totalMs).toISOString().slice(11, 19);
});

Vue.filter("timeToHourMinFormat", min => {
  if (!min) return "00:00:00";

  const date = toHoursAndMinutes(min * 60);
  const hours = date.h.toString().padStart(2, "0");
  const mins = date.m.toString().padStart(2, "0");
  const secs = date.s.toString().padStart(2, "0");

  return `${hours}:${mins}:${secs}`;
});

Vue.filter("secondToMinFormat", second => {
  if (!second) return "00:00";

  const date = toHoursAndMinutes(second);
  const mins = date.m.toString().padStart(2, "0");
  const secs = date.s.toString().padStart(2, "0");

  return `${mins}:${secs}`;
});

Vue.filter("digitWithComma", digits => {
  if (!digits) return "0";

  return digits.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
});

Vue.filter("initialNameFormat", name => {
  if (!name.fullName) return "";

  return i18n.t("3437", { first: name.first, last: name.last });
});

Vue.filter("firstCharName", name => {
  if (!name.fullName) return "";

  return fullNameFormat(name).trim().slice(0,1);
});
